import { render } from "./Datatable.vue?vue&type=template&id=3a2b3f1f&ts=true"
import script from "./Datatable.vue?vue&type=script&lang=ts"
export * from "./Datatable.vue?vue&type=script&lang=ts"

import "./Datatable.vue?vue&type=style&index=0&id=3a2b3f1f&lang=postcss"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__